import React, { useState } from 'react';
import { pick } from 'lodash';

import EditorBodyLayout from 'app/developer-v3/layouts/EditorBodyLayout';
import FlowForm from 'app/common/components/FlowForm';
import FormaticConfig from 'app/developer-v3/FormaticConfig';
import { setReadOnly } from 'app/developer-v3/utils';
import { useCurrentVersionReadOnlyReason } from 'app/developer-v3/hooks';

import { fieldTemplates } from './fieldTemplates';

import type { Middleware as MiddlewareType } from 'app/developer-v3/platformSchema/middleware';

import type { FormValues } from './types';

type Props = {
  isSaving: boolean;
  middleware: MiddlewareType;
  saveMiddleware: (middleware: MiddlewareType) => void;
};

function Middleware(props: Props) {
  const { isSaving, middleware, saveMiddleware } = props;
  const [formValues, setFormValues] = useState<FormValues>(
    pick(middleware, ['afterResponse', 'beforeRequest'])
  );

  const isReadOnly = !!useCurrentVersionReadOnlyReason();

  const parsedFormFields = setReadOnly(fieldTemplates, isReadOnly);

  return (
    <EditorBodyLayout
      isDisabled={isReadOnly}
      isSaving={isSaving}
      onSave={() => saveMiddleware({ ...middleware, ...formValues })}
    >
      <FlowForm
        config={FormaticConfig}
        fields={parsedFormFields}
        isValid={true}
        onChange={(nextFormValues: FormValues) => {
          setFormValues(nextFormValues);
        }}
        value={formValues}
      />
    </EditorBodyLayout>
  );
}

export default Middleware;
